module.exports = __webpack_public_path__ + "static/media/new-launches.1e4fb7a6.webp";